import React, { useEffect, useState } from "react";
import { useForm, useWatch } from "react-hook-form";
import { useSelector, useDispatch } from "react-redux";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { debounce } from 'lodash';
import { ButtonLoader } from "./Loader";
import { addRec, editRec } from "../services";
import {
  errorToast,
  imageWarningMsg,
  isOutOfOfficeForceWarningMsg,
  isOutOfOfficeWarningMsg,
  PageSizeOptionArr,
  successToast,
  toastDisplay,
} from "../_helpers/utilities";
import { DefaultProfilePic, IsOutOfOffice, PerPageData } from "../store/actions";
import { info } from "../services/common";

const Profile = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    getValues,
    control,
    clearErrors,
    reset,
  } = useForm({
    defaultValues: {
      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
      isOutOfOffice: false,
      isOutOfOfficeAPIError: false,
      isOutOfOfficeAPIErrorMsg: "",
      pageSize: "",
    },
  });

  const oldPasswordVal = useWatch({
    control,
    name: "oldPassword",
  });
  const newPasswordVal = useWatch({
    control,
    name: "newPassword",
  });
  const isOutOfOfficeVal = useWatch({
    control,
    name: "isOutOfOffice",
  });
  const isOutOfOfficeAPIErrorVal = useWatch({
    control,
    name: "isOutOfOfficeAPIError",
  });
  const isOutOfOfficeAPIErrorMsgVal = useWatch({
    control,
    name: "isOutOfOfficeAPIErrorMsg",
  });

  const dispatch = useDispatch();
  // const history = useHistory();
  const {
    info: userInfo,
    profilePic,
    isOutOfOffice,
  } = useSelector((state) => state.user);

  const { PageSize: DefaultPageSize } = useSelector((state) => state.common);

  const DefaultImage = () => {
    if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
      setImagePreview(process.env.REACT_APP_IMAGE_BASE_URL + profilePic);
    } else {
      setImagePreview(profilePic);
    }
  };

  const [imagePreview, setImagePreview] = useState(null);
  const [imageFile, setImageFile] = useState(null);
  const [submitLoader, setSubmitLoader] = useState(false);
  const [perPageLoader, setperPageLoader] = useState(false);
  const [outOfOfficeLoader, setOutOfOfficeLoader] = useState(false);
  const [outOfOfficeDirectFalseLoader, setOutOfOfficeDirectFalseLoader] =
    useState(false);
  const [openModal, setOpenModal] = React.useState(false);
  const [modalFileTypeContent, setModalFileTypeContent] = React.useState(false);
  const [employeeData, setEmployeeData] = React.useState();

  useEffect(() => {
    getInfo();
  }, []);
  const getInfo = async () => {
    let data = await info(`/MasterEmployee/${userInfo?.employeeId}`);
    if (data?.status === 200) {
      //console.log(data)
      setValue("pageSize", data?.data);
      setEmployeeData(data?.data);
    }
  };

  const ModalResetFunc = () => {
    if (modalFileTypeContent) {
      setOpenModal(false);
      setImageFile(null);
      DefaultImage();
    } else {
      setOpenModal(false);
      setModalFileTypeContent(false);
      setValue("isOutOfOfficeAPIError", false);
      setValue("isOutOfOfficeAPIErrorMsg", "");
    }
  };
  const ModalSuccessFunc = () => {
    if (modalFileTypeContent) {
      setOpenModal(false);
      ImageUploadAPI();
    } else {
      UpdateOutOfOfficeAPI(true, false);
      // setOpenModal(false)
      setModalFileTypeContent(false);
    }
  };

  const warningModal = () => {
    return (
      <Modal show={openModal}>
        <Modal.Header>
          <Modal.Title>
            {modalFileTypeContent
              ? imageWarningMsg
              : isOutOfOfficeAPIErrorVal
                ? isOutOfOfficeForceWarningMsg
                : isOutOfOfficeWarningMsg}
          </Modal.Title>
        </Modal.Header>
        {isOutOfOfficeAPIErrorVal && (
          <Modal.Body>
            <span className="text-danger">
              {isOutOfOfficeAPIErrorMsgVal}
            </span>
          </Modal.Body>
        )}
        <Modal.Footer>
          <Button
            variant="secondary"
            disabled={outOfOfficeLoader}
            onClick={() => ModalResetFunc()}
          >
            {modalFileTypeContent ? "Cancel" : "No"}
          </Button>
          <Button
            variant="danger"
            onClick={() => ModalSuccessFunc()}
            disabled={outOfOfficeLoader}
          >
            {modalFileTypeContent ? (
              "Upload"
            ) : outOfOfficeLoader ? (
              <ButtonLoader />
            ) : (
              "Yes"
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };
  const warningModalFunc = React.useMemo(
    () => warningModal(),
    [
      openModal,
      modalFileTypeContent,
      outOfOfficeLoader,
      isOutOfOfficeAPIErrorVal,
    ]
  );

  const UpdateOutOfOfficeAPI = async (val, ForceEdit) => {
    let CheckAPIError = getValues("isOutOfOfficeAPIError");
    setOutOfOfficeLoader(true);
    let OutOfResult;
    let req = {
      isOutOfOffice: val,
      isForceedit: CheckAPIError ? CheckAPIError : ForceEdit,
    };
    OutOfResult = await editRec(`/MasterEmployee/UpdateOutOfOffice`, req);
    if (OutOfResult.status === 200) {
      dispatch(IsOutOfOffice(val));

      setOpenModal(false);
      setOutOfOfficeDirectFalseLoader(false);
      setModalFileTypeContent(false);
      successToast(OutOfResult.message);
      setValue("isOutOfOffice", val);
      if (CheckAPIError) {
        setValue("isOutOfOfficeAPIError", false);
      }
    } else if (OutOfResult.status === 400) {
      setValue("isOutOfOfficeAPIError", true);
      setValue("isOutOfOfficeAPIErrorMsg", OutOfResult.message);
      if (outOfOfficeDirectFalseLoader) {
        errorToast(OutOfResult.message);
        setOutOfOfficeDirectFalseLoader(false);
      } else {
        setOutOfOfficeDirectFalseLoader(false);
      }
    } else {
      errorToast(OutOfResult.message);
    }
    setOutOfOfficeLoader(false);
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImageFile(file);
        setImagePreview(reader.result);
        setOpenModal(true);
        setModalFileTypeContent(true);
      };
      reader.readAsDataURL(file);
    }
  };

  const ImageUploadAPI = async () => {
    let imageResult;
    if (imageFile) {
      const formData = new FormData();

      formData.append("ProfilePic", imageFile);
      formData.append("FileName", imageFile?.name);

      imageResult = await addRec(`/Users/UpdateProfilePhoto`, formData);

      if (imageResult.status === 200) {
        if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
          setImagePreview(
            process.env.REACT_APP_IMAGE_BASE_URL + imageResult?.data
          );
        } else {
          setImagePreview(imageResult?.data);
        }
        setImageFile(null);
        dispatch(DefaultProfilePic(imageResult?.data));
      } else {
        toastDisplay(imageResult);
      }
    }
  };

  const onSubmit = async (data) => {
    setSubmitLoader(true);
    delete data.pageSize
    const oldPassword = data?.oldPassword;
    const newPassword = data?.newPassword;
    let result = await editRec(
      `/Users/ChangePassword/${oldPassword},${newPassword}`
    );
    if (result?.status === 200) {
      successToast(result?.message);
      // history.push("/quotation");
      setSubmitLoader(false);
    } else {
      toastDisplay(result);
      setSubmitLoader(false);
    }
  };

  React.useEffect(() => {
    clearErrors("oldPassword");
    clearErrors("newPassword");
  }, [oldPasswordVal]);

  React.useEffect(() => {
    clearErrors("newPassword");
  }, [newPasswordVal]);

  React.useEffect(() => {
    DefaultImage();
  }, [profilePic]);

  React.useEffect(() => {
    setValue("isOutOfOffice", isOutOfOffice);
  }, [isOutOfOffice]);

  const [isVisible, setVisible] = useState([]);
  const [isVisibleToggle, setVisibleToggle] = useState(false);

  const toggle = (val) => {
    setVisibleToggle((old) => !old);
    let oldVal = isVisible;
    if (isVisible?.length > 0) {
      if (isVisible.includes(val)) {
        let newVal = oldVal?.filter((flt) => flt !== val);
        setVisible(newVal);
      } else {
        oldVal.push(val);
        setVisible(oldVal);
      }
    } else {
      oldVal.push(val);
      setVisible(oldVal);
    }
  };


  const PageSizeFunc = async (e) => {
    if (e.target.value === "") {
      return null
    } else {
      setperPageLoader(true);
      let result = await addRec(
        `/Users/UpdatePageSize?PageSize=${e.target.value}`
      );
      if (result?.status === 200) {
        dispatch(PerPageData(e.target.value.toString()))
        successToast(result?.message);
        setperPageLoader(false);
      } else {
        toastDisplay(result);
        setperPageLoader(false);
      }
    }
  }

  return (
    <div className="approval">
      <section class="mian_part">
        <div class="titlediv titleclass">
          <h1 class="comntitle">Profile</h1>
          <div className="flow-tttt">
            <label class="cu_form_label">
              <span>
                {outOfOfficeDirectFalseLoader && <ButtonLoader />}{" "}
                {"Out Of Office "}
              </span>
              <input
                class="toggle-checkbox"
                name="isOutOfOffice"
                onChange={(e) => {
                  if (e.target.checked) {
                    setOpenModal(true);
                    setModalFileTypeContent(false);
                  } else {
                    UpdateOutOfOfficeAPI(false, true);
                    setOutOfOfficeDirectFalseLoader(true);
                  }
                }}
                checked={isOutOfOfficeVal}
                type="checkbox"
              />
              <div class="toggle-switch"></div>
            </label>
          </div>
        </div>
        <>
          <form>
            <div class="row">
              <div class="col-md-4 text-center">
                <div className="profilebigsiz">
                  <div className="editbtnbox">
                    <i class="fa fa-pencil"></i>
                    <input
                      type="file"
                      accept=".jpg, .png, .jpeg, .svg"
                      className="edit-but"
                      {...register("profileImage")}
                      onChange={handleImageChange}
                      onClick={(event) => {
                        event.target.value = null;
                      }}
                    />
                  </div>

                  {imagePreview && (
                    <img
                      src={imagePreview}
                      alt="Profile"
                      className="profilpic"
                    />
                  )}
                </div>
              </div>
              <div class="col-md-8">
                <div className="row mx-0 g-3">
                  <div class="col-md-4">
                    <div class="input-group">
                      <label className="cu_form_label">User name</label>
                      <input
                        type="text"
                        value={userInfo?.userName}
                        disabled
                        required
                        className={errors.userName ? "error" : ""}
                        {...register("userName")}
                      />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="input-group">
                      <label className="cu_form_label">Name</label>
                      <input type="text" value={userInfo?.firstName} disabled />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="input-group">
                      <label className="cu_form_label">Email</label>
                      <input type="text" value={userInfo?.email} disabled />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="input-group">
                      <label className="cu_form_label">Phone</label>
                      <input type="text" value={userInfo?.phone} disabled />
                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="input-group">
                      <label className="cu_form_label">Department</label>
                      <input
                        type="text"
                        value={employeeData?.departmentName}
                        disabled
                      />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="input-group">
                      <label className="cu_form_label">Designation</label>
                      <input
                        type="text"
                        value={employeeData?.designationName}
                        disabled
                      />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="input-group">
                      <label className="cu_form_label">
                        Per Page
                      </label>
                      <div className="passwordToggle">
                        <select
                          defaultValue={DefaultPageSize}
                          {...register("PageSize", {
                            onChange: (e) => {
                              PageSizeFunc(e);
                            },
                          })}
                          className='form-control'
                        >
                          {PageSizeOptionArr.map((item) => <option value={item?.page}>{item?.page}</option>)}
                        </select>
                      </div>
                    </div>
                    {/* </div> */}
                    <div class="col-md-1">
                      {perPageLoader && <i class="fas fa-spinner fa-spin"></i>}
                    </div>
                  </div>
                  <hr />
                </div>
                {!userInfo?.ldapVerification && (
                  <div className="row mx-0 g-3">
                    <div class="col-md-4">
                      <div class="input-group">
                        <label className="cu_form_label">
                          Old Password <sup>*</sup>
                        </label>
                        <div className="passwordToggle">
                          <input
                            type={
                              isVisible?.includes("oldPassword")
                                ? "text"
                                : "password"
                            }
                            id="oldPassword"
                            name="oldPassword"
                            required
                            placeholder={
                              errors.oldPassword ? errors.oldPassword.message : ""
                            }
                            className={errors.oldPassword ? "error" : ""}
                            {...register("oldPassword", {
                              required: "Old password is required",
                            })}
                          />
                          <span
                            className="icon"
                            onClick={() => toggle("oldPassword")}
                          >
                            {isVisible.includes("oldPassword") ? (
                              <i class="fa fa-eye-slash" aria-hidden="true"></i>
                            ) : (
                              <i class="fa fa-eye" aria-hidden="true"></i>
                            )}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="input-group">
                        <label className="cu_form_label">
                          New Password <sup>*</sup>
                        </label>
                        <div className="passwordToggle">
                          <input
                            type={
                              isVisible?.includes("newPassword")
                                ? "text"
                                : "password"
                            }
                            id="newPassword"
                            name="newPassword"
                            required
                            placeholder={
                              errors.newPassword ? errors.newPassword.message : ""
                            }
                            className={errors.newPassword ? "error" : ""}
                            {...register("newPassword", {
                              required: "New password is required",
                            })}
                          />
                          <span
                            className="icon"
                            onClick={() => toggle("newPassword")}
                          >
                            {isVisible.includes("newPassword") ? (
                              <i class="fa fa-eye-slash" aria-hidden="true"></i>
                            ) : (
                              <i class="fa fa-eye" aria-hidden="true"></i>
                            )}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="input-group">
                        <label className="cu_form_label">
                          Confirm Password <sup>*</sup>
                        </label>
                        <div className="passwordToggle">
                          <input
                            type={
                              isVisible?.includes("confirmPassword")
                                ? "text"
                                : "password"
                            }
                            id="confirmPassword"
                            name="confirmPassword"
                            required
                            placeholder={
                              errors.confirmPassword
                                ? errors.confirmPassword.message
                                : ""
                            }
                            className={errors.confirmPassword ? "error" : ""}
                            {...register("confirmPassword", {
                              required: "Confirm password is required",
                              validate: (value) => value === newPasswordVal,
                            })}
                          />
                          <span
                            className="icon"
                            onClick={() => toggle("confirmPassword")}
                          >
                            {isVisible.includes("confirmPassword") ? (
                              <i class="fa fa-eye-slash" aria-hidden="true"></i>
                            ) : (
                              <i class="fa fa-eye" aria-hidden="true"></i>
                            )}
                          </span>
                        </div>
                      </div>
                      {errors.confirmPassword &&
                        errors.confirmPassword.type === "validate" && (
                          <span className="text-danger">
                            Password and confirm password does not match
                          </span>
                        )}
                    </div>
                    {/* <div className="row"> */}

                    <div class="col-12">
                      <div class="groupbtn">
                        <button
                          class="Comnbtn OutlineRedBtn"
                          disabled={submitLoader}
                          type="submit"
                          onClick={handleSubmit(onSubmit)}
                        >
                          {submitLoader ? <ButtonLoader /> : "Save"}
                        </button>
                      </div>
                    </div>
                  </div>
                )}


              </div>
            </div>
            {warningModalFunc}
          </form>
        </>
      </section>
    </div>
  );
};

export default Profile;
